import { useNavigate } from "react-router-dom";
import { Dialog, DialogTitle, DialogContent, DialogContentText, DialogActions, Button } from "@mui/material";
import { useTranslation } from "react-i18next";
import { useLocale } from "../contexts/LocaleContext";

export default function UpgradeAccountDialog({ open, onClose, message }) {
  const navigate = useNavigate();
  const { t } = useTranslation();
  const { localizePath } = useLocale();

  const handleUpgrade = () => {
    onClose?.();
    navigate(localizePath("/billing"));
  };

  return (
    <Dialog open={open} onClose={onClose} maxWidth="xs" fullWidth>
      <DialogTitle
        sx={{
          fontFamily: '"Cal Sans", "Inter", sans-serif',
          fontWeight: 600,
          color: "#111827",
          fontSize: 18,
        }}
      >
        {t("upgradeAccountDialog.title")}
      </DialogTitle>
      <DialogContent>
        <DialogContentText
          sx={{
            color: "#6b7280",
            fontSize: 14,
            lineHeight: 1.6,
          }}
        >
          {message || t("upgradeAccountDialog.defaultMessage")}
        </DialogContentText>
      </DialogContent>
      <DialogActions sx={{ px: 3, pb: 2, pt: 1 }}>
        <Button onClick={onClose} sx={{ textTransform: "none" }}>
          {t("upgradeAccountDialog.close")}
        </Button>
        <Button
          variant="contained"
          onClick={handleUpgrade}
          sx={{
            bgcolor: "#111827",
            textTransform: "none",
            "&:hover": { bgcolor: "#374151" },
          }}
        >
          {t("upgradeAccountDialog.upgradeAccount")}
        </Button>
      </DialogActions>
    </Dialog>
  );
}
